// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 17:13:37

export default {
  "id": "sokoban-puzzle-game",
  "slug": "sokoban-puzzle-game",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/45af7a66facc4ea7bb7572715b9d0e10-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/45af7a66facc4ea7bb7572715b9d0e10/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "sokoban puzzle game",
      "description": "Push the Box game is an addictive and challenging puzzle game. It will help you train your brain. The operation of the game is very simple, move the box pusher by using the four direction buttons: up, down, left and right, push all the boxes to the specified position, the game is considered successful. If you are a fan of matching puzzle games, you will love our game. Keep your brain sharp while relaxing, having fun and relieving stress. Come and enjoy playing this puzzle game!",
      "instructions": "Move the box pusher by using the four direction buttons up, down, left and right in the game interface.",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "minigame"
      ]
    },
    "zh-CN": {
      "title": "推箱子益智游戏",
      "description": "推箱游戏是一款令人上瘾且富有挑战性的益智游戏。它将帮助你训练大脑。游戏操作非常简单，通过使用四个方向按钮：上、下、左和右，移动推箱者，将所有箱子推到指定位置，游戏就算成功。如果你是匹配益智游戏的粉丝，你将喜欢我们的游戏。在放松、娱乐和缓解压力的同时保持大脑敏锐。来享受这款益智游戏吧！",
      "instructions": "通过游戏界面中的上、下、左、右四个方向按钮移动箱子推动者。",
      "genres": [
        "拼图"
      ],
      "tags": [
        "小游戏"
      ]
    },
    "zh-TW": {
      "title": "推箱解謎遊戲",
      "description": "推箱遊戲是一款上癮且挑戰性高的益智遊戲。它將幫助你鍛鍊大腦。遊戲操作非常簡單，使用四個方向按鈕：上、下、左和右，移動推箱者，將所有箱子推到指定的位置，遊戲即算成功。如果你是配對益智遊戲的粉絲，你會喜歡我們的遊戲。在放鬆、娛樂和緩解壓力的同時，保持你的大腦敏捷。來享受這款益智遊戲吧！",
      "instructions": "使用遊戲介面中的上、下、左、右四個方向按鈕移動箱子推拉器。",
      "genres": [
        "謎題"
      ],
      "tags": [
        "小遊戲"
      ]
    },
    "zh-HK": {
      "title": "擋箱遊戲謎題",
      "description": "推箱遊戲是一款上癮且挑戰性高的益智遊戲。它將幫助你鍛煉腦力。遊戲操作非常簡單，使用四個方向按鈕：上、下、左、右，移動推箱者，將所有箱子推到指定的位置，遊戲即算成功。如果你是配對益智遊戲的粉絲，你將會喜歡我們的遊戲。在放鬆、娛樂和釋放壓力的同時，保持腦力鋒利。來享受這款益智遊戲吧！",
      "instructions": "用遊戲介面中的四個方向按鈕上、下、左、右移動盒子推動器。",
      "genres": [
        "謎題"
      ],
      "tags": [
        "迷你遊戲"
      ]
    },
    "ja": {
      "title": "ソコバンパズルゲーム",
      "description": "Push the Boxゲームは、魅力的で挑戦的なパズルゲームです。脳を鍛えるのに役立ちます。ゲームの操作は非常に簡単で、上、下、左、右の4つの方向ボタンを使ってボックスを押すキャラクターを動かし、すべてのボックスを指定された位置に押すことで、ゲームが成功とされます。マッチングパズルゲームのファンなら、私たちのゲームを大好きになるでしょう。リラックスしながら脳を鋭く保ち、楽しみながらストレスを解消しましょう。このパズルゲームを楽しみにしてくれ！",
      "instructions": "ゲームインターフェースの上、下、左、右の方向ボタンを使ってボックスプーザーを動かしてください。",
      "genres": [
        "パズル"
      ],
      "tags": [
        "ミニゲーム"
      ]
    },
    "ko": {
      "title": "소코반 패자드 게임",
      "description": "패션 블록 게임은 중독성이 있고 도전적인 퍼즐 게임입니다. 뇌를 훈련해 주는 데 도움이 됩니다. 게임의 작동 방식은 매우 간단합니다. 네 가지 방향 버튼(위, 아래, 왼쪽, 오른쪽)을 사용하여 박스 푸셔를 이동시키고, 모든 박스를 지정된 위치에 밀어야 합니다. 이렇게 하면 게임이 성공으로 간주됩니다. 매치 퍼즐 게임 팬이신 분이라면, 우리의 게임을 사랑하게 될 것입니다. 쉬면서 뇌를 명확하게 유지하고, 즐기며 스트레스를 풀세요. 이 퍼즐 게임을 즐겨보세요!",
      "instructions": "게임 인터페이스에서 상, 하, 좌, 우 방향 버튼을 사용하여 박스 푸셔를 이동하세요.",
      "genres": [
        "퍼즐"
      ],
      "tags": [
        "미니게임"
      ]
    },
    "fr": {
      "title": "Jeu de puzzle Sokoban",
      "description": "Le jeu Push the Box est un puzzle game captivant et défifiant. Il vous aidera à entraîner votre cerveau. L'opération du jeu est très simple, déplacez le mancheur de boîte en utilisant les quatre boutons de direction : haut, bas, gauche et droite, pousser toutes les boîtes à la position spécifiée, le jeu est considéré comme réussi. Si vous êtes fan des jeux de puzzle de correspondance, vous aimerez notre jeu. Gardez votre cerveau acéré tout en vous détendant, en vous amusant et en vous déstressant. Venez jouer à ce jeu de puzzle !",
      "instructions": "Déplacez le propulseur de boîte en utilisant les touches de direction haut, bas, gauche et droite dans l'interface de jeu.",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "jeu miniature"
      ]
    }
  }
};
